/* eslint-disable max-len */
import {
  LIQUID_PIXEL_VISUALIZER_FAILED,
  LIQUID_PIXEL_VISUALIZER_SUCCESSFUL,
  LIQUID_PIXEL_VISUALIZER_ACTIVE_TEXTURE,
  LIQUID_PIXEL_SET_CHECKING_VALID_TEXTURE,
} from '../actions/liquidPixel/actionTypes';
import { APP_MOUNT } from '../actions/actionTypes';

export const initialState = {
  errorLoadingLiquidPixelVisualizer: false,
  validTexture: null,
  checkingValidTexture: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_MOUNT: {
      return {
        ...initialState,
      };
    }
    case LIQUID_PIXEL_VISUALIZER_FAILED: {
      return {
        ...state,
        errorLoadingLiquidPixelVisualizer: true,
      };
    }
    case LIQUID_PIXEL_VISUALIZER_SUCCESSFUL: {
      return {
        ...state,
        errorLoadingLiquidPixelVisualizer: false,
      };
    }
    case LIQUID_PIXEL_VISUALIZER_ACTIVE_TEXTURE: {
      return { ...state, validTexture: action.active };
    }
    case LIQUID_PIXEL_SET_CHECKING_VALID_TEXTURE: {
      return { ...state, checkingValidTexture: action.active };
    }
    default:
      return state;
  }
};
